import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { Settings} from "../../../../types/settingGroups";


interface GroupState {
    loading: boolean;
    error: string | null;
    data: Settings;
}

const initialState: GroupState = {
    loading: false,
    error: null,
    data: {} as Settings,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        settingsRequested: (state) => {
            state.loading = true;
            state.error = null;
        },
        settingsReceived: (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        },
        settingsRequestFailed: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    settingsRequested,
    settingsReceived,
    settingsRequestFailed,
} = settingsSlice.actions;

export const settingsReducer = settingsSlice.reducer;